import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal, ModalBody, Button } from "reactstrap";
import { FaSearch, FaChartLine, FaListOl } from "react-icons/fa";

export const TOUR_EVENT = "dejachart:open-tour";
const STORAGE_KEY = "dejachart-welcomed";

const CALLOUTS = [
  {
    icon: FaSearch,
    text: "We've already loaded an example search — see today's closest historical analogs for a real ticker.",
  },
  {
    icon: FaChartLine,
    text: "The chart overlays the current pattern against its best historical matches.",
  },
  {
    icon: FaListOl,
    text: "Scroll down for win/loss stats and the forward return distribution across every match.",
  },
];

export default function WelcomeModal() {
  const loggedIn = useSelector((state: RootReducerState) => state.authentication.loggedIn);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (loggedIn && !localStorage.getItem(STORAGE_KEY)) {
      setIsOpen(true);
    }
  }, [loggedIn]);

  useEffect(() => {
    const handler = () => {
      localStorage.removeItem(STORAGE_KEY);
      setIsOpen(true);
    };
    window.addEventListener(TOUR_EVENT, handler);
    return () => window.removeEventListener(TOUR_EVENT, handler);
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setIsOpen(false);
  };

  const handleTryIt = () => {
    dismiss();
    navigate("/dashboard");
  };

  return (
    <Modal isOpen={isOpen} toggle={dismiss} centered size="md">
      <ModalBody style={{ padding: "2rem", textAlign: "center" }}>
        <div
          style={{
            width: 64, height: 64, borderRadius: "50%",
            background: "rgba(59, 130, 246, 0.1)", color: "var(--primary)",
            display: "flex", alignItems: "center", justifyContent: "center",
            margin: "0 auto 1rem",
          }}
        >
          <FaSearch size={26} />
        </div>

        <h4 style={{ fontWeight: 700, marginBottom: "0.75rem" }}>Welcome to DejaChart</h4>
        <p style={{ color: "var(--text-muted)", lineHeight: "1.7", marginBottom: "1.5rem" }}>
          DejaChart finds historical analogs for any stock's current chart pattern, then shows
          you what happened next. Let's jump straight into the Query Matcher.
        </p>

        <ul style={{ listStyle: "none", padding: 0, margin: "0 0 1.5rem", textAlign: "left" }}>
          {CALLOUTS.map((c, i) => {
            const Icon = c.icon;
            return (
              <li key={i} className="d-flex align-items-start gap-2" style={{ marginBottom: "0.85rem" }}>
                <Icon size={16} style={{ color: "var(--primary)", marginTop: "3px", flexShrink: 0 }} />
                <span style={{ color: "var(--text-muted)", fontSize: "0.92rem", lineHeight: "1.5" }}>
                  {c.text}
                </span>
              </li>
            );
          })}
        </ul>

        <div className="d-flex flex-column gap-2">
          <Button color="primary" onClick={handleTryIt} style={{ fontWeight: 600 }}>
            Try It Now
          </Button>
          <Button
            color="link"
            onClick={dismiss}
            style={{ color: "var(--text-muted)", fontSize: "13px" }}
          >
            Skip tour
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}
